import { render, staticRenderFns } from "./RoundIcon.vue?vue&type=template&id=23f3cbf8&"
import script from "./RoundIcon.vue?vue&type=script&lang=js&"
export * from "./RoundIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports